(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("ReactTransformTenchmark"), require("@beisen/chaos-ui"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "ReactTransformTenchmark", "@beisen/chaos-ui", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["BeisenCloudUI"] = factory(require("react"), require("ReactTransformTenchmark"), require("@beisen/chaos-ui"), require("react-dom"));
	else
		root["BeisenCloudUI"] = factory(root["React"], root["ReactTransformTenchmark"], root["@beisen/chaos-ui"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_18__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition